import { render, staticRenderFns } from "./BlogOffersTable.vue?vue&type=template&id=463226c5"
import script from "./BlogOffersTable.vue?vue&type=script&lang=js"
export * from "./BlogOffersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports